module.exports = __webpack_public_path__ + "static/media/arrow-blue-top.78e1dc5c.png";